// extracted by mini-css-extract-plugin
module.exports = {"btn":"ConsignmentLookup_btn__2LBHs","camera":"ConsignmentLookup_camera__1rlUy"};